import * as React from 'react'
import Spinner from '../components/Spinner'
import moment from 'moment/min/moment-with-locales'
moment.locale('pl')

class FishReservationsLogScreen extends React.Component {

  componentDidMount() {
    if( !this.props.fish.fishReservationsLog)
      this.props.getFishReservationsLog()
    
    if( !this.props.users.userListWithType.restaurant )
      this.props.getUserListWithType('restaurant')
    if( !this.props.users.userListWithType.fisherman )
      this.props.getUserListWithType('fisherman')
  }

  renderFishReservationLog(log, key) {
    const fishDetail = this.props.fish.fishTypes.filter(f => f.id===log.fishType)[0],
          restaurant = this.props.users.userListWithType.restaurant.filter(r => r.id===log.restaurantId)[0],
          fisherman = this.props.users.userListWithType.fisherman.filter(r => r.id===log.fisherId)[0]
    return (
      <div className="list-group-item d-flex flex-row" key={key}>
        <div className="row">
          <div className="col-md-3">
            <img 
              alt=""
              className="img-thumbnail mr-3" 
              src={fishDetail.img ? fishDetail.img : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAACC2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iWE1QIENvcmUgNS40LjAiPgogICA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPgogICAgICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIgogICAgICAgICAgICB4bWxuczp0aWZmPSJodHRwOi8vbnMuYWRvYmUuY29tL3RpZmYvMS4wLyI+CiAgICAgICAgIDx0aWZmOlJlc29sdXRpb25Vbml0PjI8L3RpZmY6UmVzb2x1dGlvblVuaXQ+CiAgICAgICAgIDx0aWZmOkNvbXByZXNzaW9uPjE8L3RpZmY6Q29tcHJlc3Npb24+CiAgICAgICAgIDx0aWZmOk9yaWVudGF0aW9uPjE8L3RpZmY6T3JpZW50YXRpb24+CiAgICAgICAgIDx0aWZmOlBob3RvbWV0cmljSW50ZXJwcmV0YXRpb24+MjwvdGlmZjpQaG90b21ldHJpY0ludGVycHJldGF0aW9uPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KD0UqkwAAAA1JREFUCB1j+PXr138ACc4D7lyDGJAAAAAASUVORK5CYII='}
            />
          </div>
          <div className="col-md-9">
            <p>{fishDetail.name}, {log.reservationAmount} {fishDetail.amount.quantity ? 'sztuk' : 'kg'}, {log.fisherPrice}zł/{fishDetail.amount.quantity ? 'sztukę' : 'kg'} </p>
            <p className="small text-muted">Cena ofertowana przez restaurację to {log.reservationPrice}zł, cena rybaka to {log.fisherPrice}zł</p>
            <p className="small text-muted">Restauracja zamówiła {log.reservationAmount} {fishDetail.amount.quantity ? 'sztuk' : 'kg'}, razem rybak dodał na targ {log.fisherAmount} {fishDetail.amount.quantity ? 'sztuk' : 'kg'}</p>

            <p className="small">
              Restauracja: 
              {restaurant.name ? restaurant.name : null}
              {restaurant.phone ? `${"\n"}Tel: ${restaurant.phone}` : null}
            </p>
            <p className="small">
              Rybak: 
              {fisherman.firstName ? fisherman.firstName : null}
              {fisherman.lastName ? fisherman.lastName : null}
              {fisherman.phone ? `${"\n"}Tel: ${fisherman.phone}` : null}
            </p>

            <p className="small text-muted mb-1">Zamówienie z: {moment(log.time.seconds*1000).format('DD MMMM, H:mm')}</p>

            <div className="alert alert-success small">{log.message}</div>
          </div>
        </div>
      </div>
    )
  }

  render() {
    const { fishReservationsLog } = this.props.fish,
          { restaurant, fisherman } = this.props.users.userListWithType
    

    if( fishReservationsLog===null || restaurant===null || fisherman===null ) return <Spinner />
    else if( !fishReservationsLog.length )
      return (
      <div className="alert alert-info">
        Obecnie brak aktywnych logów
      </div>)
    else
      return (
        <div className="list-group">
            {fishReservationsLog.map( (r, key) => (
                this.renderFishReservationLog(r, key)
            ))}
        </div>
      )
  }
}

export default FishReservationsLogScreen



// WEBPACK FOOTER //
// ./src/screens/FishReservationLogScreen.js